import React, { useRef, useState } from 'react'
import './PostOnPremsi.css'
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Nav from '../../components/Nav/Nav';
import VerifyEmailComponent from '../../components/rememberverifyemail';
import { auth } from '../../firebase';
import { Helmet } from 'react-helmet';
import FAQcomponent from '../../components/FAQcomponent/FAQcomponent';
import { AiFillDollarCircle } from "react-icons/ai";
import { MdGroups } from "react-icons/md";
import { IoHeartSharp } from "react-icons/io5";
import { AiOutlineSafety } from "react-icons/ai";
import JumpingImages from '../../components/jumpingimages';
import PremsiTutorialButton from '../../components/PremsiTutorialButton';
import BenefitsSection from '../../components/BenefitsSection/BenefitsSection';
import ReferralCTA from '../../components/ReferralCTA/ReferralCTA';

function PostOnPremsi() {
    const [featureshow, setfeatureshow] = useState(1);
    const [showearnings, setshowearnings] = useState(1);

    const myRef = useRef(null)
    const navigate = useNavigate()
    const isMobile = window.innerWidth <= 850;

    return (
        <>
            <Helmet>
                {/* Open Graph Meta Tags */}
                <meta property="og:title" content="Premsi - Our App❤️" />
                <meta property="og:description" content="Premsi | Sell and market digital content in seconds. Download the Premsi App for more features. Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
                <meta property="og:url" content="https://premsi.com/postonpremsi" />
                <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
                <meta property="og:site_name" content="Premsi - sell digital content" />

                <title>Premsi - Sell digital content in minutes❤️</title>
                <meta name="description" content="Premsi | Post and earn on Premsi. Download the Premsi App for more features. Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
                <link rel="canonical" href="https://premsi.com/postonpremsi" />
            </Helmet>
            <Nav />
            {auth.currentUser === null || auth.currentUser === undefined || auth.currentUser.emailVerified === true ? null : <VerifyEmailComponent />}
            <div className='loginscreen_app' ref={myRef}>
                <div className='loginscreenouterbody' style={{ width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.65)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div className='loginscreen__body'>
                        <div style={{ width: "95%", flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-around" }}>
                            <h1 style={{ color: "white", marginBottom: 10, width: "100%", textAlign: "center" }}>Post your content on Premsi App 🎉</h1>
                            <h3 style={{ color: "white", marginBottom: 15, width: "80%", textAlign: "center" }}>Create free and paid content in form of pictures/videos/PDFs and paid groups!</h3>
                            <h3 style={{ color: "white", marginBottom: 15, width: "80%", textAlign: "center" }}>Your Posts will attract new followers and fans to purchase your premium content!</h3>
                            <h3 style={{ color: "white", marginBottom: 5, width: "80%", textAlign: "center" }}>Explore more of our exciting features in our App!</h3>
                            <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-around", marginBottom: 20, marginTop: 10 }}>
                                <a href="https://apps.apple.com/app/apple-store/id6446628909" style={{ cursor: "pointer", display: "flex", alignItems: "center" }} target='_blank'><img loading="lazy" src={require('../../images/appstore.webp')} style={{ cursor: "pointer", height: 50, borderRadius: 5 }} alt="Premsi.com App store link" /></a>
                                <a href="https://play.google.com/store/apps/details?id=com.Premsi.app" style={{ cursor: "pointer", display: "flex", alignItems: "center" }} target='_blank'><img loading="lazy" src={require('../../images/googleplay.webp')} style={{ cursor: "pointer", height: 50, borderRadius: 5, borderColor: "black", borderWidth: 1, borderStyle: "solid" }} alt="Premsi.com Google play store link" /></a>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center", marginTop: 20 }}>
                                <img loading="lazy" src={require('../../images/creator.webp')} style={{ marginLeft: 0, height: 44, width: 150, borderRadius: 55 }} alt="Premsi.com logo app icon" />
                                <h5 style={{ color: "white", marginTop: 10 }}>Trusted by 2,000<span className="font-body-inline">+</span> creators! | 2M$ paid out</h5>
                            </div>
                        </div>
                    </div>
                    {/* here 4 images that jump */}
                    {isMobile === false ? <JumpingImages /> : null}
                </div >
            </div >

            <div className='whatispremsimainmain'>
                <div className='whatispremsitop' style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
                    <p style={{ fontSize: 23, fontWeight: "bold", color: "black" }}>What is Premsi? </p>
                    <img loading="lazy" src={require('../../images/pblue-min.webp')} style={{ marginLeft: 10, height: 25, width: 25, borderRadius: 5 }} alt="Premsi.com logo app icon" />
                </div>

                <p className='premsiexplanationp'>Premsi is a social media app that lets you sell digital products—like videos, PDFs, courses, and exclusive content—directly to your fans in under 30 seconds, with instant delivery and payouts. 🔥</p>

                {/* here 4 images that jump */}
                {isMobile === true ? <JumpingImages /> : null}

                {/*<div className='whatispremsimainhome'>
                    <div className='whatispremsidivhome'>
                        <p style={{ fontSize: 30, marginTop: -20 }}>⏱</p>
                        <p>1 minute to create an Account and start to Sell / Buy or both 🚀</p>
                    </div>

                    <div className='whatispremsidivhome'>
                        <p style={{ fontSize: 30, marginTop: -20 }}>🏦</p>
                        <p>Premsi is free</p>
                        <p>No monthly subscription</p>
                        <p>85% daily payout</p>
                    </div>

                    <div className='whatispremsidivhome'>
                        <p style={{ fontSize: 30, marginTop: -20 }}>⭐️</p>
                        <p>Exploring / Marketing / Selling in an one-in-all App + Website</p>
                    </div>

                    <div className='whatispremsidivhome'>
                        <p style={{ fontSize: 30, marginTop: -20 }}>🔥</p>
                        <p>Fans can buy your content without logging in</p>
                    </div>
                </div>*/}

                <div class="premsi-features-section">
                    <div class="premsi-feature">
                        <AiFillDollarCircle size={50} color='#009ffd' />
                        <h3 class="premsi-feature-title">Creative Ownership</h3>
                        <p class="premsi-feature-text">Premsi creators own 100% of their content and keep 85% of all earnings.</p>
                    </div>
                    <div class="premsi-feature">
                        <MdGroups size={50} color='#009ffd' />
                        <h3 class="premsi-feature-title">Inclusivity</h3>
                        <p class="premsi-feature-text">All creators deserve a safe and inclusive space to connect and share.</p>
                    </div>
                    <div class="premsi-feature">
                        <IoHeartSharp size={50} color='#009ffd' />
                        <h3 class="premsi-feature-title">Freedom</h3>
                        <p class="premsi-feature-text">Creators are free to express their most authentic selves through their content.</p>
                    </div>
                    <div class="premsi-feature">
                        <AiOutlineSafety size={50} color='#009ffd' />
                        <h3 className="premsi-feature-title">All<span className="font-body-inline">-</span>In<span className="font-body-inline">-</span>One</h3>
                        <p class="premsi-feature-text">Exploring / Marketing / Selling all on Premsi possible</p>
                    </div>
                </div>


                <PremsiTutorialButton/>

                {/* here have social media icons */}

                {/*<div className='socialbar' >
                    <p style={{ fontSize: 15, opacity: 0.75 }}>seen on</p>
                    <div className='innersocialbigger' >
                        <img className='socialbarimage' alt='Hacker news logo' src={require('../../images/socialforbar/hn.webp')} />
                        <img className='socialbarimage' alt='Twitter X logo' src={require('../../images/socialforbar/x.webp')} />
                    </div>
                    <div className='innersocialbigger' >
                        <img className='socialbarimage' alt='Tiktok logo' src={require('../../images/socialforbar/tt.webp')} />
                        <img className='socialbarimage' alt='Product Hunt logo' src={require('../../images/socialforbar/producthunt.webp')} />
                    </div>
                    <div className='innersocialsmaller' >
                        <img className='socialbarimage' alt='Instagram logo' src={require('../../images/socialforbar/ig.webp')} />
                    </div>
                </div>*/}

                {/*Here start explained our features */}
                <BenefitsSection selectedId={featureshow} onSelect={setfeatureshow} />
                {/*Here end explained our features */}
                {/*<button className='faq__button' onClick={() => (navigate("/faq"))}>Our FAQs</button>*/}
            </div>

            <div className='everyuserdivsecondnotlogin'>
                <div className='everyuserdivinnersecondnotlogin fees-banner'>
                    <h3 className='fees-banner__title'>Fees 💰</h3>
                    <p className='fees-banner__text'>And all that for 0$. No monthly subscription. No credit card required. Nothing!</p>
                    <p className='fees-banner__text fees-banner__text--highlight'>We only earn once you make money and 85% goes directly to you</p>
                </div>
            </div>

            {/*<div className='explainappdiv_app'>
                <h2>Easy to use App</h2>
                <div className='explainappinnerdiv'>
                    <div className='explainappthirddiv'>
                        <h4 style={{ color: "black", textAlign: "center", marginBottom: 20 }}>1️⃣ The feed to explore/market</h4>
                        <img loading="lazy" className='explainappthirdimgnormal' src={require('../../images/pic1.webp')} alt="Premsi.com feed to explore" />
                    </div>

                    <div className='explainappthirddiv'>
                        <h4 style={{ color: "black", textAlign: "center", marginBottom: 20 }}>2️⃣ Buy premium messages</h4>
                        <img loading="lazy" className='explainappthirdimgnormal' src={require('../../images/premiummessage.webp')} alt="Premsi.com easily buy premium messages" />
                    </div>

                    <div className='explainappthirddiv'>
                        <h4 style={{ color: "black", textAlign: "center", marginBottom: 20 }}>3️⃣ Easily sell premium messages</h4>
                        <img loading="lazy" className='explainappthirdimg' src={require('../../images/pic2.webp')} alt="Premsi.com easily sell premium messages" />
                    </div>

                    <div className='explainappthirddiv'>
                        <h4 style={{ color: "black", textAlign: "center", marginBottom: 20 }}>4️⃣ Create free/paid subscription groups</h4>
                        <img loading="lazy" className='explainappthirdimg' src={require('../../images/groups1.webp')} alt="Premsi.com easily create free/paid subscription groups" />
                    </div>
                </div>
            </div>
*/}
            {/* FAQ section */}
            <FAQcomponent />

            {/*<div style={{ height: 150, marginBottom: 30, width: "100%", backgroundColor: "black", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h3 style={{ color: "white", marginBottom: 10, width: "80%", textAlign: "center" }}>bar with animation that shows different earnings 🎉</h3>
                <h4 style={{ color: "white", marginBottom: 15, width: "80%", textAlign: "center" }}>grid of pics</h4>
                    </div>*/}

            <ReferralCTA
                title={<>Refer friends <span className="font-body-inline">&</span> receive 5<span className="font-body-inline">%</span> of their spendings for life 🔥</>}
                subtitle={<>Whenever they subscribe to Premsi<span className="font-body-inline">+</span>, tip someone or buy a premium message you'll earn.</>}
                onButtonClick={() => navigate("/profile")}
            />

            {/*<div className='explainappdivwhatcreatorsachieved'>
                <h2>What our creators achieve ❤️</h2>

                {showearnings === 1 ?
                    <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/1pm.webp')} alt="Premsi.com earnings example" />
                    : (showearnings === 2 ?
                        <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/2pm.webp')} alt="Premsi.com earnings example" />
                        : (showearnings === 3 ?
                            <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/3pm.webp')} alt="Premsi.com earnings example" />
                            : (showearnings === 4 ?
                                <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/4pm.webp')} alt="Premsi.com earnings example" />
                                :
                                <img loading="lazy" className='creatorsachievedimage' src={require('../../images/pmearnings/5pm.webp')} alt="Premsi.com earnings example" />
                            )))}

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 14 }}>
                    <div onClick={() => setshowearnings(1)} style={{cursor:"pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 1 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(2)} style={{cursor:"pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 2 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(3)} style={{cursor:"pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 3 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(4)} style={{cursor:"pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 4 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                    <div onClick={() => setshowearnings(5)} style={{cursor:"pointer", height: 14, width: 14, borderRadius: 10, backgroundColor: (showearnings === 5 ? "gray" : "lightgray"), marginRight: 10 }}></div>
                </div>
            </div>*/}

            <Footer />
        </>
    )
}

export default PostOnPremsi
